import React from 'react';
import './TokenRefreshOverlay.css';

interface TokenRefreshOverlayProps {
    onRetryLogin: () => void;
}

export const TokenRefreshOverlay: React.FC<TokenRefreshOverlayProps> = ({ onRetryLogin }) => {
    return (
        <div className="token-refresh-overlay">
            <div className="token-refresh-modal">
                <div className="token-refresh-content">
                    <div className="token-refresh-icon">
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="#dc3545" strokeWidth="2"/>
                            <path d="M12 8v4M12 16h.01" stroke="#dc3545" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h2>Sitzung abgelaufen</h2>
                    <p>
                        Ihre Anmeldesitzung ist abgelaufen oder konnte nicht erneuert werden.
                        Bitte melden Sie sich erneut an, um fortzufahren.
                    </p>
                    <button
                        className="token-refresh-login-button"
                        onClick={onRetryLogin}
                        aria-label="Erneut mit Microsoft anmelden"
                    >
                        {/* Microsoft logo */}
                        <span className="microsoft-logo" aria-hidden="true">
                            <span className="microsoft-logo-square ms-red" />
                            <span className="microsoft-logo-square ms-green" />
                            <span className="microsoft-logo-square ms-blue" />
                            <span className="microsoft-logo-square ms-yellow" />
                        </span>
                        <span>Mit Microsoft erneut anmelden</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
